import React from 'react'
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconCloseBlack } from '../assets/icons/ic-close-black.svg';

//type 1 : all
//type 2 : no title
//type 3 : no title, no cancel button
const Modal = ({ type = 1, isOpen, title, message, cancelText, confirmText, isConfirm, onConfirm, onCancel }) => {
    const { t } = useTranslation()

    return (
        isOpen &&
        <div className="absolute w-full h-full content-center whitespace-pre-line" style={{ top: 0, left: 0, background: 'rgba(0,0,0,0.3)', zIndex : 99999 }}>
            <div className="mx-auto w-[360px] h-[180px] bg-[#DEDEDE] text-center flex flex-col rounded-[8px]">
                {
                    type == 1 && (
                        <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                            <div className="">{title || 'MODAL'}</div>
                            <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                        </div>
                    )                    
                }
                {
                    type == 2 && (
                         (
                            <div className="flex h-[38px] bg-[#DEDEDE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">                            
                                <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                            </div>
                        )
                    )
                }
                {
                    type == 3 && (
                        <div className="flex h-[38px] bg-[#DEDEDE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]"></div>
                    )
                }                

                {/* <div className="flex h-[38px] bg-[#CECECE] pl-[20px] pt-[12px] pr-[12px] pb-[8px] justify-between items-center flex-shrink-0 self-stretch rounded-tl-[8px] rounded-tr-[8px]">
                    <div className="">{title || 'MODAL'}</div>
                    <IconCloseBlack className="ml-auto cursor-pointer" onClick={() => { onCancel() }}/>
                </div> */}
                <div className="flex-1 flex items-center justify-center bg-[#DEDEDE] px-[20px]">{message || 'MODAL Message'}</div>
                {
                    isConfirm ?
                    <div className="flex items-center justify-end bg-[#DEDEDE] px-[20px] py-[12px] rounded-bl-[8px] rounded-br-[8px]">
                        <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] mr-[8px]  gap-[8px] rounded-[6px] border border-[#B8B8B8] bg-gradient-to-b from-[#FFF] to-[#DEDEDE] cursor-pointer text-[#000] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onCancel() }}>{cancelText || t('modal.close')}</div>
                        <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onConfirm() }} >{confirmText || t('modal.confirm')}</div>                    
                    </div> :
                    // type != 3 ? <div className="h-[32px] cursor-pointer" onClick={() => { onCancel() }}>Close</div> : <div className="h-[32px] cursor-pointer"></div>
                    type != 3 ? 
                    (
                        <div className='flex items-center justify-end pr-[20px] pb-[12px]'>
                            <div className="flex items-center justify-center w-[88px] h-[28px] px-[8px] py-[7px] gap-[8px] rounded-[6px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] cursor-pointer text-[#FFF] text-center font-pretendard text-[16px] font-light leading-[110%]" onClick={() => { onCancel() }}>{cancelText || t('modal.close')}</div>
                        </div>

                    )
                    : <div className="h-[32px] cursor-pointer"></div>
                }                
            </div>
        </div>
    )
}

export default Modal